export class GetMicroWorkOrdersRequest {
  User: string;
  Environment: NonNullable<"LIVE" | "TEST" | "DEV" | "LOCAL" | "">;
}
